import { useState, useEffect, useRef } from "react";
import { getAllbarbers, deleteBarber } from "../../api/barberApi";
import { useAuth } from "../../context/AuthContext";

const useBarber = () => {
  const [editbarber, setEditbarber] = useState();
  const [deletedBarber, setDeletedBarber] = useState();
  const [barberList, setBarberList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [errorMsg, setErrorMsg] = useState();

  const sectionRef = useRef(null);
  const { user } = useAuth();
  useEffect(() => {
    fetchBarbers();
  }, []);
  useEffect(() => {
    if (!showModal) {
      setEditbarber(null);
    } else {
    }
  }, [showModal]);

  const onEditClick = (id) => {
    if (barberList) {
      var barber = barberList.find((b) => b.id == id);
      setEditbarber(barber);
      setShowModal(true);
      if (showModal) {
        scrollToSection();
      }
    }
  };
  const scrollToSection = () => {
    sectionRef.current.scrollIntoView({ behavior: "smooth" });
  };
  const onClearbarber = () => {
    if (editbarber) {
      setEditbarber(null);
      setShowModal(false);
    }
  };
  const fetchBarbers = async () => {
    if (user) {
      const response = await getAllbarbers(user.barberShop);
      setBarberList(response);
    }
  };
  const handleConfirmDelete = async () => {
    try {
      const response = await deleteBarber(deletedBarber.id, user.barberShop);
      setSuccessMsg(response.message);
      setShowDeleteModal(false);
      setDeletedBarber(null);
      fetchBarbers();
    } catch (err) {
      setErrorMsg(err.response?.data?.message || "Delete failed.");
      setShowDeleteModal(false);
      setDeletedBarber(null);
    }
  };
  const handleDeleteClick = (barber) => {
    setDeletedBarber(barber);
    setShowDeleteModal(true);
  };
  const onCloseDeleteModal = () => {
    setDeletedBarber(null);
    setShowDeleteModal(false);
  };

  return {
    barberList,
    showModal,
    setShowModal,
    showDeleteModal,
    editbarber,
    sectionRef,
    successMsg,
    errorMsg,
    fetchBarbers,
    onEditClick,
    onClearbarber,
    handleDeleteClick,
    handleConfirmDelete,
    onCloseDeleteModal,
  };
};
export default useBarber;
